import { useRef, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";

import {
  getSelectedParcels,
  getAvailableMergeSplitStops,
} from "../../../store/selectors/ui/routeDetail";
import { wrapPromise } from "../../../utils/promise";
import { splitStopActionCreators } from "../../../store/actions/ui/routeDetail/splitStop";

export default () => {
  const splitStopModalRef = useRef();
  const dispatch = useDispatch();

  const dropdownListStops = useSelector(getAvailableMergeSplitStops);
  const selectedParcels = useSelector(getSelectedParcels);

  const {
    onApplySplit,
    fetchDestinationStop,
    hideSplitStopNotifications,
  } = useMemo(() => bindActionCreators(splitStopActionCreators, dispatch), [
    dispatch,
  ]);

  const openSplitStopsModal = useCallback(
    () =>
      wrapPromise(
        splitStopModalRef.current.showModal({
          dropdownListStops,
          selectedParcels,
          onApplySplit,
          fetchDestinationStop,
          hideSplitStopNotifications,
        })
      ),
    [
      dropdownListStops,
      selectedParcels,
      onApplySplit,
      fetchDestinationStop,
      hideSplitStopNotifications,
    ]
  );

  return {
    splitStopModalRef,
    openSplitStopsModal,
  };
};
